// Genere depuis le dictionnaire : les mots les plus longs (13 lettres et plus, sans les tons, premier mot de la
// tete, hors renvois). parts : decoupage par repetition (jamais par syllabes).
export const LONGEST_WORDS = [
  {
    "word": "dongodongodongo",
    "letters": 15,
    "parts": [
      "dongo",
      "dongo",
      "dongo"
    ],
    "fr": "regarder d'un air menaçant/punitif",
    "en": "to look in a threatening/punishing way",
    "es": "mirar con aire amenazador/punitivo",
    "de": "strafend, drohend ansehen.",
    "example": "jombwa ná dongodongodongo"
  },
  {
    "word": "bíngidibìngidi",
    "letters": 14,
    "parts": [
      "bíngidi",
      "bìngidi"
    ],
    "fr": "étendus en grand nombre sur le sol, se roulant",
    "en": "lying in great numbers on the ground, rolling around",
    "es": "tendidos en gran número sobre el suelo, revolcándose",
    "de": "(bíngìlane) in Menge auf dem Boden liegend, sich wälzend.",
    "example": null
  },
  {
    "word": "mungambongambo",
    "letters": 14,
    "parts": [
      "mu",
      "ngambo",
      "ngambo"
    ],
    "fr": "le héron gris",
    "en": "the grey heron",
    "es": "la garza gris",
    "de": "der graue Fischreiher.",
    "example": null
  },
  {
    "word": "sámbwàsambwanɛ",
    "letters": 14,
    "parts": [
      "sámbwà",
      "sambwa",
      "nɛ"
    ],
    "fr": "être partout couvert de honte",
    "en": "to be entirely covered in shame",
    "es": "estar completamente cubierto de vergüenza",
    "de": "überall zu Schanden werden.",
    "example": null
  },
  {
    "word": "sɛngwɛsɛngwɛnɛ",
    "letters": 14,
    "parts": [
      "sɛngwɛ",
      "sɛngwɛ",
      "nɛ"
    ],
    "fr": "rôder près de quelqu'un (pour obtenir un cadeau ou espionner quelque chose), parasiter",
    "en": "to hang around someone (to get a gift or to spy on something), to sponge off",
    "es": "merodear cerca de alguien (para obtener un regalo o espiar algo), aprovecharse",
    "de": "sich in der Nähe von jemand herumtreiben, (um ein Geschenk zu erhalten oder etwas auszuspionieren), schmarotzen.",
    "example": null
  },
  {
    "word": "wíngìdiwíngìdi",
    "letters": 14,
    "parts": [
      "wíngìdi",
      "wíngìdi"
    ],
    "fr": "rond, parfaitement rond, sphérique",
    "en": "round, perfectly round, spherical",
    "es": "redondo, perfectamente redondo, esférico",
    "de": "rund, kugelrund.",
    "example": null
  },
  {
    "word": "wúngùduwúngùdu",
    "letters": 14,
    "parts": [
      "wúngùdu",
      "wúngùdu"
    ],
    "fr": "en train de rouler",
    "en": "rolling",
    "es": "rodando",
    "de": "(wúngùlane) rollend, wälzend.",
    "example": null
  },
  {
    "word": "ñɔ́ngɔ̀lɔñɔ́ngɔ̀lɔ",
    "letters": 14,
    "parts": [
      "ñɔ́ngɔ̀lɔ",
      "ñɔ́ngɔ̀lɔ"
    ],
    "fr": "brillant (en s'enduisant de pommade)",
    "en": "shiny (from applying ointment)",
    "es": "brillante (por untarse con pomada)",
    "de": "(sich) glänzend (einreiben mit Salbe).",
    "example": null
  },
  {
    "word": "ngɔyéngayènga",
    "letters": 13,
    "parts": [
      "ngɔ",
      "yénga",
      "yènga"
    ],
    "fr": "femme qui aime bavarder, en particulier qui aime s'enfuir avec un autre homme",
    "en": "a woman who likes to gossip, especially one who likes to run off with another man",
    "es": "una mujer a la que le gusta chismear, especialmente una que le gusta fugarse con otro hombre",
    "de": "ein Bakoko-Wort, von Frauen gesagt, die gerne schwatzen; besond. von solchen, die gerne zu einem and. Mann davonlaufen (sómbo).",
    "example": null
  },
  {
    "word": "témbàtembangɛ",
    "letters": 13,
    "parts": [
      "témbà",
      "temba",
      "ngɛ"
    ],
    "fr": "se donner du mal, entreprendre quelque chose",
    "en": "to take pains, to undertake something",
    "es": "esforzarse, emprender algo",
    "de": "(témbè) sich abmühen, etwas unternehmen (= takatakane, lémbàlembane).",
    "example": null
  }
];
